import { SmsReportsConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const SMSReportActions = {
    searchSmsReport,
};

function searchSmsReport(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: SmsReportsConstants.SEARCH_SMSREPORTS_REQUEST,
            data: null
        }));
        adminUsersServices.searchSmsReports(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: SmsReportsConstants.SEARCH_SMSREPORTS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: SmsReportsConstants.SEARCH_SMSREPORTS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: SmsReportsConstants.SEARCH_SMSREPORTS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}